import { render, staticRenderFns } from "./CSBackOrderList.vue?vue&type=template&id=be9721e8&lang=pug&"
import script from "./CSBackOrderList.vue?vue&type=script&lang=js&"
export * from "./CSBackOrderList.vue?vue&type=script&lang=js&"
import style0 from "./CSBackOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports